import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { getHoldPayoutId, validateHoldReason } from './confirmedHold';

export default function ConfirmedHoldModal({ row, onClose, onRefresh }) {
    const [reason, setReason] = useState('');
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');
    const [finished, setFinished] = useState(false);
    const locked = useRef(false);
    const dialog = useRef(null);
    const input = useRef(null);
    useEffect(() => {
        const previous = document.activeElement;
        input.current?.focus();
        return () => previous?.focus?.();
    }, []);

    const submit = async event => {
        event.preventDefault();
        if (locked.current || finished) return;
        const error = validateHoldReason(reason);
        if (error) { setMessage(error); return; }
        const payoutId = getHoldPayoutId(row);
        if (!payoutId) { setMessage('지급 ID를 확인할 수 없습니다. 목록을 다시 조회해주세요.'); return; }
        locked.current = true;
        setBusy(true);
        setMessage('');
        try {
            const { data } = await axios.post(`${process.env.REACT_APP_API}/api/settlement/hold-confirmed`, {
                payout_id: payoutId, reason: reason.trim(),
            }, { withCredentials: true, timeout: 15000 });
            if (data?.code === 1000) {
                setMessage(data?.data?.already_held ? '이미 보류된 건입니다.' : '보류 처리되었습니다.');
            } else {
                setMessage(data?.msg || '보류 처리 결과를 확인하지 못했습니다. 목록을 확인해주세요.');
            }
        } catch (error) {
            setMessage(error.response?.data?.msg || '처리 결과를 확인하지 못했습니다. 목록을 다시 확인한 후 진행해주세요.');
        } finally {
            // Do not blindly retry after an ambiguous result: this endpoint has no request key.
            setFinished(true);
            setBusy(false);
            onRefresh();
        }
    };
    const keyDown = event => {
        if (event.key === 'Escape' && !busy) { event.preventDefault(); onClose(); }
        if (event.key === 'Tab') {
            const items = dialog.current.querySelectorAll('button:not(:disabled),textarea:not(:disabled)');
            const first = items[0], last = items[items.length - 1];
            if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
            else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
        }
    };
    return <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.45)', zIndex: 10000, display: 'grid', placeItems: 'center', padding: 20 }}>
        <section ref={dialog} role="dialog" aria-modal="true" aria-labelledby="confirmed-hold-title" onKeyDown={keyDown}
            style={{ background: '#fff', borderRadius: 12, padding: 24, width: '100%', maxWidth: 460, maxHeight: '90vh', overflow: 'auto' }}>
            <h2 id="confirmed-hold-title" style={{ fontSize: 20, marginBottom: 20 }}>입금 보류</h2>
            <dl style={{ lineHeight: 1.9, marginBottom: 16 }}>
                <dt>가맹점</dt><dd>{row.co_nm || '-'}</dd>
                <dt>입금액</dt><dd>{Number(row.final_amount).toLocaleString('ko-KR')}원</dd>
                <dt>현재 상태</dt><dd>확정 · 송금 대기</dd>
            </dl>
            <form onSubmit={submit}>
                <label htmlFor="confirmed-hold-reason">보류 사유 (필수)</label>
                <textarea ref={input} id="confirmed-hold-reason" value={reason} onChange={event => setReason(event.target.value)}
                    maxLength={500} disabled={busy || finished} rows={4} style={{ width: '100%', border: '1px solid #ccc', padding: 10, marginTop: 8 }} />
                <p style={{ textAlign: 'right', color: '#666' }}>{reason.length}/500</p>
                <p style={{ margin: '12px 0', color: '#666' }}>보류된 건은 송금 대상에서 제외됩니다. 현재 화면에서는 보류 해제를 지원하지 않습니다.</p>
                {message && <p role="status" style={{ margin: '12px 0' }}>{message}</p>}
                <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                    <button type="button" disabled={busy} onClick={onClose} style={{ padding: '10px 16px' }}>{finished ? '닫기' : '취소'}</button>
                    {!finished && <button type="submit" disabled={busy} style={{ padding: '10px 16px', background: '#b45309', color: '#fff', borderRadius: 6 }}>{busy ? '처리 중…' : '보류로 변경'}</button>}
                </div>
            </form>
        </section>
    </div>;
}
